import { render, staticRenderFns } from "./SidebarFuncionario.vue?vue&type=template&id=fbc08c26&scoped=true&"
import script from "./SidebarFuncionario.vue?vue&type=script&lang=js&"
export * from "./SidebarFuncionario.vue?vue&type=script&lang=js&"
import style0 from "./SidebarFuncionario.vue?vue&type=style&index=0&id=fbc08c26&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fbc08c26",
  null
  
)

export default component.exports